import GrievanceContent from './Grievances/GrievanceContent'
import Banner from './shared/banner'

export default function Grievance() {
  return (
    <main>
      <div className="bg-gradient-to-r from-[#5D6A5D] to-[#193C34] w-full h-[64px] md:h-[80px] xl:h-[100px] 2xl:h-[90px]"></div>
      <GrievanceContent />
    </main>
  )
}
